function injectStyle (ssrContext) {
  require("!!../../../../../../../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?minimize!../../../../../../../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-775aac4e\",\"scoped\":true,\"hasInlineConfig\":true}!stylus-loader!../../../../../../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Warning.vue")
}
var Component = require("!../../../../../../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!../../../../../../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Warning.vue"),
  /* template */
  require("!!../../../../../../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-775aac4e\",\"hasScoped\":true,\"preserveWhitespace\":false}!../../../../../../../../../../../node_modules/vue-loader/lib/template-compiler/preprocessor?engine=pug!../../../../../../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Warning.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-775aac4e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/profile/blocks/children/sidebar/components/childrenlist/child/components/warning/Warning.vue
// module id = 1463b8841fb4d8a9616d
// module chunks = 89